import { transient } from "aurelia-framework";
import { RulesClientService } from "../../../../../services/rules/rules-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";

@transient()
export class BusinessUnitRuleDialog {

    public overrideVettingAction: boolean = false;
    public vettingAction: string;
    private ruleConfigs: {ruleCollectionRuleConfigId:number, ruleCollectionId:number, businessUnitId:number}[];
    reload:(() => void);

    activate(model: {  ruleConfigs: {ruleCollectionRuleConfigId:number, ruleCollectionId:number, businessUnitId:number}[], vettingAction: string, reload:(() => void) }) {
        this.ruleConfigs = model.ruleConfigs;
        this.vettingAction = model.vettingAction;
        this.reload = model.reload;
        if ($(this.vettingAction).text()) {
            this.overrideVettingAction = true;
        }
    }

    constructor(private rulesClientService: RulesClientService, private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService, private i18N: I18N) {
    }

    save() {
        return new Promise<void>((resolve, reject) => {
            this.rulesClientService.overrideVettingAction(this.ruleConfigs,
                this.overrideVettingAction ? this.vettingAction : null).then(() => {
                    if(this.reload) this.reload();
                    this.notificationClientService.show(this.i18N.tr('changes-saved-successfully-text'), '', NotificationType.Success)
                    this.dialogClientService.hide();
                    resolve();
                }).catch(() => {
                    this.notificationClientService.show(this.i18N.tr('failed-to-save-text'), '', NotificationType.Error)
                    reject();
                })
        });
    }

    cancel() {
        this.dialogClientService.hide();
    }
}